import React, { useState, useEffect } from 'react';
import './Splash.css';
import logoImg from './pictures/MBC logo.png';

export default function Splash({ onComplete }) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleInteraction = () => {
      setIsVisible(false);
      if (onComplete) onComplete();
    };

    if (isVisible) {
      window.addEventListener('click', handleInteraction);
      window.addEventListener('scroll', handleInteraction);
      window.addEventListener('keydown', handleInteraction);
      window.addEventListener('touchstart', handleInteraction);

      // Auto-hide after 4 seconds
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onComplete) onComplete();
      }, 4000);

      return () => {
        window.removeEventListener('click', handleInteraction);
        window.removeEventListener('scroll', handleInteraction);
        window.removeEventListener('keydown', handleInteraction);
        window.removeEventListener('touchstart', handleInteraction);
        clearTimeout(timer);
      };
    }
  }, [isVisible, onComplete]);

  if (!isVisible) return null;

  return (
    <div className="splash-overlay">
      <div className="splash-content">
        <div className="splash-logo-wrapper">
          <img src={logoImg} alt="Maa Bhagwati Constructions" className="splash-logo-img" />
        </div>
        <h1 className="splash-title">MAA BHAGWATI<br />CONSTRUCTION</h1>
        <p className="splash-subtitle">Building Trust Since 1970s</p>
        <p className="splash-hint">Click or scroll to explore</p>
      </div>
    </div>
  );
}
